import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControlDirective, FormGroup, FormGroupDirective } from '@angular/forms';
import { EnumGenerico } from 'app/interfaces/enum/enum-generico';
import { Produto } from 'app/interfaces/enum/produto.enum';
import { getTipoSistemaKey, TipoSistema } from 'app/interfaces/enum/tipo-sistema';
import { AuthService } from 'app/main/pages/authentication/auth.service';
import { ParametroUtilsService } from 'app/utils/parametro-utils.service';

@Component({
  selector: 'app-produto-select',
  templateUrl: './produto-select.component.html',
  styleUrls: ['./produto-select.component.scss'],
})
export class ProdutoSelectComponent implements OnInit {
  // Opção principal
  @Input() filtrarProdutoPorUsuarioLogado: boolean = true;

  // NG-MODEL
  @Input() produto;
  @Output() produtoChange = new EventEmitter<any>();

  // FORM CONTROL
  @Input() fControlName: string = 'produto';
  form: FormGroup;

  // INPUT OPTIONS OPTIONS
  @Input() clearable: boolean = false;
  @Input() closeOnSelect: boolean = true;
  @Input() placeholder: string = 'Produto';
  @Input() searchable: boolean = true;
  @Input() typeToSearchText: string = 'Digite para Procurar';
  @Input() notFoundText: string = 'Nenhum item encontrado';
  @Input() readonly: boolean = false;
  @Input() multiple: boolean = false;
  @Input() maxSelectedItems: number;
  @Input() maxItemsToShow: number = 999;
  @Input() classes: string = '';
  @Input() produtosExcluidos: Produto[] = [];

  produtos = Produto;
  filteredProducts = [] as EnumGenerico[];

  constructor(
    private _authService: AuthService,
    private rootFormGroup: FormGroupDirective,
    private _parametroUtilsService: ParametroUtilsService
  ) {}

  ngOnInit(): void {
    this.filtrarProdutos();
    this.form = this.rootFormGroup.form;
  }

  onChangeProduto() {
    this.produtoChange.emit(this.produto);
  }

  /**
   * Cria uma lista de produtos;
   **/

  /* filtrarProdutos() {
    this.filteredProducts = [];

    const lista = this.filtrarProdutoPorUsuarioLogado ? this._authService.getTokenProdutos() : Object.keys(Produto);

    this.filteredProducts = lista
      .filter(valor => Produto[valor] !== Produto.TR && Produto[valor] !== Produto.CB)
      .map(valor => ({
        key: valor,
        value: Produto[valor],
      }));
  } */
  filtrarProdutos() {
    this.filteredProducts = [];

    const lista = this.filtrarProdutoPorUsuarioLogado ? this._authService.getTokenProdutos() : Object.keys(Produto);

    const tipoSistemaParametro = this._parametroUtilsService.getParametroByNome('PARAM_TIPO_SISTEMA')?.valor;

    const tipoSistemaKey = getTipoSistemaKey(tipoSistemaParametro);
    
    this.filteredProducts = lista
      .filter((valor: string) => {
        const produto = Produto[valor as keyof typeof Produto];

        if (!produto) {
          return false;
        }

        // continua ocultando CB
        if (produto === Produto.CB) {
          return false;
        }

        if (this.produtosExcluidos?.includes(produto)) {
          return false;
        }

        // Transporte Rodoviário → somente TR
        if (tipoSistemaKey === 'TRANSPORTE_RODOVIARIO') {
          return produto === Produto.TR;
        }

        // Agenciamento de Carga → IA, EA, IM e EM
        if (tipoSistemaKey === 'AGENCIAMENTO_CARGA') {
          return [Produto.IA, Produto.EA, Produto.IM, Produto.EM].includes(produto);
        }

        // Sem parâmetro definido → mostra todos permitidos
        return [Produto.IA, Produto.EA, Produto.IM, Produto.EM, Produto.TR].includes(produto);
      })
      .map((valor: string) => ({
        key: valor,
        value: Produto[valor as keyof typeof Produto],
      }));
  }
}
